import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from './../../../_services/admin.service';

import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EducationService } from 'src/app/_services/education.service';

@Component({
  selector: 'app-new-country',
  templateUrl: './new-country.component.html',
  styleUrls: ['./new-country.component.css']
})
export class NewCountryComponent implements OnInit {
  loading=true
  id=0
  country={}
  educationSystems=[]
  myForm

  constructor(
    private router:Router,
    private activatedRoute:ActivatedRoute,
    private adminService:AdminService,
    private educationService:EducationService) {
      this.initForm()
     }
  get f() {
    return this.myForm.controls;
  }

ngOnInit(): void {
this.activatedRoute.params.subscribe(
  pp=>{
  this.id=pp['id']
  if(this.id!=0){
    this.loadCountry()
  }
  this.loadEducationSystems()

})
}
loadCountry(){
  this.adminService.getCountry(this.id).subscribe(
    cc=>{
      this.country=cc
      this.initForm()
    }
  )
}

loadEducationSystems(){
  this.educationService.getEducationSystems().subscribe(
    x=>{
      this.educationSystems=x
      this.loading=false
    }
  )
  }

  initForm(){
    this.myForm = new FormGroup({
      file: new FormControl('', [Validators.required]),
      fileSource: new FormControl('', [Validators.required]),
      educationSystem: new FormControl(this.country['server_education_system_id'], [Validators.required]),
      shortName: new FormControl(this.country['short_name'],[Validators.required])
    });
  }
  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.myForm.patchValue({
        fileSource: file
      });
    }
  }

  submit() {
    this.loading=true
    const formData = new FormData();
    formData.append('myFile', this.myForm.get('fileSource').value);
    formData.append('education_system_id',this.f.educationSystem.value)
    formData.append('shortName',this.f.shortName.value)

    this.adminService.saveNewCountry(formData).subscribe(
      xx=>{
        if(xx['isnew'] || xx['is_match']){
          this.loading=false
          this.router.navigate(["/admin/countries"])
         }
      }
    )
  }

}
